(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-offers-hero"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(root.dataset.ready==='true')return;
    root.dataset.ready='true';
    var slides=[].slice.call(root.querySelectorAll('.pp-offers-hero__slide'));
    var dots=[].slice.call(root.querySelectorAll('.pp-offers-hero__dot'));
    if(slides.length<2)return;
    var index=0,timer=null,paused=false,hover=false,focus=false,visible=true;
    var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var interval=Number(root.dataset.interval)||6000;
    function show(next){
      index=(next+slides.length)%slides.length;
      slides.forEach(function(slide,i){
        var active=i===index;
        slide.classList.toggle('is-active',active);
        slide.setAttribute('aria-hidden',active?'false':'true');
        slide.inert=!active;
      });
      dots.forEach(function(dot,i){
        dot.classList.toggle('is-active',i===index);
        dot.setAttribute('aria-current',i===index?'true':'false');
      });
    }
    function stop(){if(timer){clearInterval(timer);timer=null}}
    function start(){
      stop();
      if(!reduce&&!paused&&!hover&&!focus&&visible&&!document.hidden)timer=setInterval(function(){show(index+1)},interval);
    }
    root.querySelectorAll('[data-go]').forEach(function(button){button.addEventListener('click',function(){show(Number(button.dataset.go));start()})});
    root.querySelectorAll('[data-direction]').forEach(function(button){button.addEventListener('click',function(){show(index+Number(button.dataset.direction));start()})});
    var pause=root.querySelector('.pp-offers-hero__pause');
    if(pause)pause.addEventListener('click',function(){paused=!paused;pause.setAttribute('aria-pressed',paused?'true':'false');pause.setAttribute('aria-label',paused?'Reanudar diapositivas':'Pausar diapositivas');pause.textContent=paused?'▶':'Ⅱ';start()});
    root.addEventListener('mouseenter',function(){hover=true;start()});
    root.addEventListener('mouseleave',function(){hover=false;start()});
    root.addEventListener('focusin',function(){focus=true;start()});
    root.addEventListener('focusout',function(){focus=root.contains(document.activeElement);start()});
    document.addEventListener('visibilitychange',start);
    if('IntersectionObserver' in window)new IntersectionObserver(function(entries){visible=entries[0].isIntersecting;start()},{threshold:.2}).observe(root);
    document.addEventListener('shopify:block:select',function(event){if(!root.contains(event.target))return;var slide=event.target.closest('.pp-offers-hero__slide');if(slide){show(Number(slide.dataset.slide));paused=true;start()}});
    start();
  }
  document.querySelectorAll('.pp-offers-hero').forEach(init);
  document.addEventListener('shopify:section:load',function(event){event.target.querySelectorAll('.pp-offers-hero').forEach(init)});
})();

  } catch(e) { console.error(e); }
})();
})();
